;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './app-download-block.scss')]).then(() => {
    $('.widget.app-download-block').each(function (i, el) {
      $(el).data('widget', new AppDownloadBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function AppDownloadBlock(el, Swiper) {
  const self = this
  self.el = $(el)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('AppDownloadBlock init', self)
    }
    self.el.css('opacity', 1)
  }
}
